export default {"src":"/_next/static/media/garlic.1e2e801a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};